// CSS ANIMATION FOR THE HERO IMAGE SLIDERS AND TEXTS

const AnimationStyle = () => {
  return (
    <style jsx>{`
      @keyframes slideInLeft {
        0% {
          transform: translateX(-100%);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes slideInRight {
        0% {
          transform: translateX(100%);
          opacity: 0;
        }
        100% {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes slideInTop {
        0% {
          transform: translateY(-100%);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes slideInBottom {
        0% {
          transform: translateY(100%);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      .animate-slideInLeft {
        animation: slideInLeft 1s ease-out forwards;
      }

      .animate-slideInRight {
        animation: slideInRight 1s ease-out forwards;
      }

      .animate-slideInTop {
        animation: slideInTop 1s ease-out forwards;
      }

      .animate-slideInBottom {
        animation: slideInBottom 1s ease-out forwards;
      }

      .animate-fadeIn {
        animation: fadeIn 1s ease-out forwards;
      }
    `}</style>
  );
};

export default AnimationStyle;
